import { Component } from '@angular/core';

@Component({
  selector: 'app-api-endpoints-desc',
  templateUrl: './api-endpoints-desc.component.html',
  styleUrl: './api-endpoints-desc.component.scss'
})
export class ApiEndpointsDescComponent {

}
